<template>
  <button class="button" @click="onClick" :class="[mode]">
    <AssetV3
      v-if="hasIcon"
      class="icon"
      dir="icons"
      :name="iconName"
    />
    <p class="button-text white">{{ content }}</p>
  </button>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  name: 'installments-button',
  components: { AssetV3 },
  props: {
    content: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
    },
    hasIcon: {
      type: Boolean,
    },
    iconName: {
      type: String,
    },
  },
  methods: {
    onClick(value) {
      this.$emit('click', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/__new-styles.scss';

  .button {
    position: relative;
    border: 0;
    -webkit-tap-highlight-color: transparent;
    width: 100%;
    background-color: $primary-500;
    border-radius: 4px;
    height: 48px;

    @media (min-width: $lg) {
      display: flex;
      gap: 4px;
      justify-content: space-between;
      align-items: center;
    }

    p {
      font-weight: 700;
      font-family: var(--font-family);
      line-height: 24px;
    }

    .icon {
      position: absolute;
      top: 16px;
      left: 20px;

      @media (min-width: $lg) {
        position: unset;
        top: unset;
        left: unset;
      }
    }

    &:hover {
      background-color: $primary-700;
    }

    @media (min-width: $lg) {
      height: 38px;
    }

    &.semi-primary {
      background-color: var(--white);
      border:1px solid var(--gray-300);

      p {
        font-family: var(--font-family);
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        color: var(--gray-700) !important;

        @media (min-width: $lg) {
          font-size: 16px;
          line-height: 24px;
        }
      }

      &:hover {
        background-color: $primary-300;
      }
    }
    &.secundary {
      background-color: var(--blue-200);
      border:1px solid var(--blue-200);

      p {
        font-family: var(--font-family);
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: var(--blue-400) !important;

        @media (min-width: $lg) {
          font-size: 16px;
          line-height: 24px;
        }
      }

      &:hover {
        background-color: $primary-300;
      }
    }
    .button-text {
      font-family: var(--font-family);
      font-weight: 600;
      font-size: 18px;
      line-height: 28px;

      @media (min-width: $lg) {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
</style>
